import TranscriptWord from '../models/TranscriptWord';
import { cleanText } from './text';
import { calculateDuration } from './common';

/**
 * Gets all words from a transcript
 * @param {Object} transcript - The transcript object
 * @returns {TranscriptWord[]} Array of transcript words
 */
export const getTranscriptWords = (transcript) => {
  if (!transcript || !transcript.words) return [];
  return transcript.words.map(word => new TranscriptWord(word));
};

/**
 * Cleans the text of a transcript
 * @param {Object} transcript - The transcript object
 * @returns {string} The cleaned text
 */
export const cleanTranscriptText = (transcript) => {
  if (!transcript || !transcript.text) return '';
  return cleanText(transcript.text);
};

/**
 * Calculates the duration of a transcript
 * @param {Object} transcript - The transcript object
 * @returns {string} The formatted duration
 */
export const getTranscriptDuration = (transcript) => {
  if (!transcript || !transcript.words || transcript.words.length === 0) {
    return '0.00';
  }

  const firstWord = transcript.words[0];
  const lastWord = transcript.words[transcript.words.length - 1];
  return calculateDuration(firstWord.start, lastWord.end);
}; 